import React, { useState } from 'react';
import SweetAlert from "react-bootstrap-sweetalert";
import defaultImage from "assets/img/image_placeholder.jpg";
import defaultAvatar from "assets/img/placeholder.jpg";
import ImageUpload from "components/CustomUpload/ImageUpload.js";
import RichTextEditor from "react-rte";
import styles from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.js";
import stylesData from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import { makeStyles } from "@material-ui/core/styles";
import './form.css'
import axios from "../../utils/axiosInstance";
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Card from 'components/Card/Card';
import CardHeader from 'components/Card/CardHeader';
import CardIcon from 'components/Card/CardIcon';
import { MailOutline } from '@material-ui/icons';
import CardBody from 'components/Card/CardBody';
import { Box } from '@material-ui/core';
//const baseURL = "https://jsonplaceholder.typicode.com/api/v1/admin/login";
const useStyleData = makeStyles(stylesData);


const useStyles = makeStyles(styles);

const AboutUs = () => {
  const classes = useStyles();
  const [selectedImages, setSelectedImages] = useState([]);
  const [avatar, setAvatar] = React.useState(true);
  const [file1, setFile1] = React.useState(null);
  const [file2, setFile2] = React.useState(null);
  const [file3, setFile3] = React.useState(null);
  const [file4, setFile4] = React.useState(null);
  const [selectedFile1, setSelectedFile1] = React.useState(null);
  const [imageurl1, setImageurl1] = React.useState('');
  const [imagePreviewUrl1, setImagePreviewUrl1] = React.useState(
    avatar ? defaultAvatar : defaultImage
  );
  const [selectedFile2, setSelectedFile2] = React.useState(null);
  const [imageurl2, setImageurl2] = React.useState('');
  const [imagePreviewUrl2, setImagePreviewUrl2] = React.useState(
    avatar ? defaultAvatar : defaultImage
  );
  const [selectedFile3, setSelectedFile3] = React.useState(null);
  const [imageurl3, setImageurl3] = React.useState('');
  const [imagePreviewUrl3, setImagePreviewUrl3] = React.useState(
    avatar ? defaultAvatar : defaultImage
  );
  const [selectedFile4, setSelectedFile4] = React.useState(null);
  const [imageurl4, setImageurl4] = React.useState('');
  const [imagePreviewUrl4, setImagePreviewUrl4] = React.useState(
    avatar ? defaultAvatar : defaultImage
  );
  const [editorBody1, setEditorBody1] = React.useState(RichTextEditor.createEmptyValue());
  const [editorBody2, setEditorBody2] = React.useState(RichTextEditor.createEmptyValue());
  const [editorBody3, setEditorBody3] = React.useState(RichTextEditor.createEmptyValue());
  const [editorBody4, setEditorBody4] = React.useState(RichTextEditor.createEmptyValue());

  const [formValues, setFormValues] = useState({
    whoHeading: '',
    whoDescription: '',
    whoImage: [],
    choiceHeading: '',
    choiceDescription: '',
    choiceImage: [],
    businessHeading: '',
    businessDescription: '',
    businessImage: [],
    secureHeading: '',
    secureDescription: '',
    secureImage: [],
  });
  const [alert, setAlert] = React.useState(null);

  const handleImageUpload = (e, field) => {
    const files = e.target.files;
    const imageArray = Array.from(files);
    setFormValues({
      ...formValues,
      [field]: imageArray,
    });
  };

  const handleImageChange1 = async (e) => {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];
    setSelectedFile1(e.target.files[0]);
    setFile1(file);
    reader.onloadend = () => {
      setAvatar(true);
      setImagePreviewUrl1(reader.result);
      setImageurl1(e.target.files[0])
    };
    if (file) {
      reader.readAsDataURL(file);
    }
    console.log(file, imagePreviewUrl1)
  };

  const handleImageChange2 = async (e) => {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];
    setSelectedFile2(e.target.files[0]);
    setFile2(file);
    reader.onloadend = () => {
      setAvatar(true);
      setImagePreviewUrl2(reader.result);
      setImageurl2(e.target.files[0])
    };
    if (file) {
      reader.readAsDataURL(file);
    }
    console.log(file, imagePreviewUrl2)
  };

  const handleImageChange3 = async (e) => {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];
    setSelectedFile3(e.target.files[0]);
    setFile3(file);
    reader.onloadend = () => {
      setAvatar(true);
      setImagePreviewUrl3(reader.result);
      setImageurl3(e.target.files[0])
    };
    if (file) {
      reader.readAsDataURL(file);
    }
    console.log(file, imagePreviewUrl3)
  };

  const handleImageChange4 = async (e) => {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];
    setSelectedFile4(e.target.files[0]);
    setFile4(file);
    reader.onloadend = () => {
      setAvatar(true);
      setImagePreviewUrl4(reader.result);
      setImageurl4(e.target.files[0])
    };
    if (file) {
      reader.readAsDataURL(file);
    }
    console.log(file, imagePreviewUrl1)
  };

  const handleRemove1 = () => {
    setFile1(null);
    //setAvatar(false);
    setImageurl1(null);
    setImagePreviewUrl1(defaultAvatar);
    fileInput.current.value = null;
  };

  const handleRemove2 = () => {
    setFile2(null);
    //setAvatar(false);
    setImageurl2(null);
    setImagePreviewUrl2(defaultAvatar);
    fileInput.current.value = null;
  };
  const handleRemove3 = () => {
    setFile3(null);
    //setAvatar(false);
    setImageurl3(null);
    setImagePreviewUrl3(defaultAvatar);
    fileInput.current.value = null;
  };
  const handleRemove4 = () => {
    setFile4(null);
    //setAvatar(false);
    setImageurl4(null);
    setImagePreviewUrl4(defaultAvatar);
    fileInput.current.value = null;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  React.useEffect(() => {
    console.log("sajsa")
    const fetchData = async () => {
      const token = localStorage.getItem("token");
      // setLoading(true);
      try {
        await axios
          .get(
            `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/aboutus`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Access-Control-Allow-Origin": "*",
              },
            }
          )
          .then((res) => {
            const data = res.data.data;
            console.log("sajsa", data[0])
            setFormValues({
              whoHeading: data[0]?.whoHeading,
              whoDescription: data[0]?.whoDescription,
              whoImage: data[0]?.whoImage[0],
              choiceHeading: data[0]?.choiceHeading,
              choiceDescription: data[0]?.choiceDescription,
              choiceImage: data[0]?.choiceImage[0],
              businessHeading: data[0]?.businessHeading,
              businessDescription: data[0]?.businessDescription,
              businessImage: data[0]?.businessImage[0],
              secureHeading: data[0]?.secureHeading,
              secureDescription: data[0]?.secureDescription,
              secureImage: data[0]?.secureImage[0]
            });
            setEditorBody1(RichTextEditor.createValueFromString(data[0].whoDescription, 'html'))
            setEditorBody2(RichTextEditor.createValueFromString(data[0].choiceDescription, 'html'))
            setEditorBody3(RichTextEditor.createValueFromString(data[0].businessDescription, 'html'))
            setEditorBody4(RichTextEditor.createValueFromString(data[0].secureDescription, 'html'))

            setImagePreviewUrl1(`${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/uploads/${data[0]?.whoImage[0]}`)
            setImagePreviewUrl2(`${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/uploads/${data[0]?.choiceImage[0]}`)
            setImagePreviewUrl3(`${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/uploads/${data[0]?.businessImage[0]}`)
            setImagePreviewUrl4(`${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/uploads/${data[0]?.secureImage[0]}`)
          });
      } catch (error) {
        console.error(error.message);
        if (error?.response?.data?.message == "For security reasons, we locked your account.Please login to continue") {
          localStorage.removeItem("token");
          window.location.assign("/auth/login-page");
        }
      }
      // setLoading(false);
    };

    fetchData();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    const token = localStorage.getItem("token");

    // Append form values for "who" section
    formData.append('whoHeading', formValues.whoHeading);
    formData.append('whoDescription', formValues.whoDescription);
    // formValues.whoImage.forEach((image, index) => {
    //   formData.append(`whoImage`, image);
    // });

    formData.append("whoImage", selectedFile1 ? selectedFile1 : formValues.whoImage);
    formData.append("choiceImage", selectedFile2 ? selectedFile2 : formValues.choiceImage);
    formData.append("businessImage", selectedFile3 ? selectedFile3 : formValues.businessImage);
    formData.append("secureImage", selectedFile4 ? selectedFile4 : formValues.secureImage);

    // Append form values for "businessHeading" section
    formData.append('businessHeading', formValues.businessHeading);
    formData.append('businessDescription', formValues.businessDescription);
    // formValues.whoImage.forEach((image, index) => {
    //   formData.append(`businessImage`, image);
    // });

    // Append form values for "choice" section
    formData.append('choiceHeading', formValues.choiceHeading);
    formData.append('choiceDescription', formValues.choiceDescription);
    // formValues.choiceImage.forEach((image, index) => {
    //   formData.append(`choiceImage`, image);
    // });

    // Append form values for "business" section (Repeat similar blocks for other sections)

    formData.append('secureHeading', formValues.secureHeading);
    formData.append('secureDescription', formValues.secureDescription);
    // formValues.secureImage.forEach((image, index) => {
    //   formData.append(`secureImage`, image);
    // });

    // You can now submit the formData to your API
    // Example: axios.post('your-api-endpoint', formData)
    axios.put(`${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/aboutus`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
        }
      }

    ).then((res) => {
      setAlert(
        <SweetAlert
          style={{ display: "block", marginTop: "-100px" }}
          title={
            <span
              style={{
                fontSize: "14px",
                fontWeight: "bold",
              }}
            >
              {res.data.message}
            </span>
          }
          onConfirm={() => setAlert(null)}
          onCancel={() => setAlert(null)}
          titleCssClass={classesSweetAlert.cardTitle}
          confirmBtnCssClass={
            classesSweetAlert.button + " " + classesSweetAlert.success
          }
        />
      );
    })
      .catch((err) => {
        console.warn(err);
      })
  };

  const hideAlert = () => {
    setAlert(null);
    window.location.assign("/admin/dashboard");
  };

  const handleImageRemove = (field, index) => {
    const updatedImages = [...formValues[field]];
    updatedImages.splice(index, 1);
    setFormValues({
      ...formValues,
      [field]: updatedImages,
    });
  };

  const handleEditorChange1 = (newValue) => {
    setEditorBody1(newValue);
    setFormValues({
      ...formValues,
      "whoDescription": newValue.toString("html"),
    });

  };
  const handleEditorChange2 = (newValue) => {
    setEditorBody2(newValue);
    setFormValues({
      ...formValues,
      "choiceDescription": newValue.toString("html"),
    });

  };
  const handleEditorChange3 = (newValue) => {
    setEditorBody3(newValue);
    setFormValues({
      ...formValues,
      "businessDescription": newValue.toString("html"),
    });

  };
  const handleEditorChange4 = (newValue) => {
    setEditorBody4(newValue);
    setFormValues({
      ...formValues,
      "secureDescription": newValue.toString("html"),
    });

  };

  const classesSweetAlert = useStyleData();

  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>About Us</h4>
          </CardHeader>
          <CardBody>
            <div className='form-container'>
              <form onSubmit={handleSubmit}>
                <GridContainer style={{ justifyContent: "space-between" }}>
                  <GridItem xs={12} sm={6} md={6} style={{ margin: "0px" }}>
                    <label>Who Heading:</label>
                    <input
                      type="text"
                      name="whoHeading"
                      value={formValues.whoHeading}
                      onChange={handleInputChange}
                      style={{ width: "100%", height: "50px", }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={6} md={4} style={{ margin: "0px" }}>
                    <h2 style={{ margin: "0px 0px 10px 0px" }}>Who Images:</h2>

                    <ImageUpload
                      avatar
                      fileValue={file1}
                      imagePreviewUrlValue={imagePreviewUrl1}
                      handleImageChange={handleImageChange1}
                      handleRemove={handleRemove1}
                      addButtonProps={{
                        color: "rose",
                        round: true,
                      }}
                      changeButtonProps={{
                        color: "rose",
                        round: true,
                      }}
                      removeButtonProps={{
                        color: "danger",
                        round: true,
                      }}
                    />
                  </GridItem>
                </GridContainer>

                <div>
                  <label>Who Description:</label>

                  <RichTextEditor
                    value={editorBody1}
                    onChange={handleEditorChange1}
                    style={{ height: "300px" }}
                  />
                </div>
                <GridContainer style={{ justifyContent: "space-between" }}>
                  <GridItem xs={12} sm={6} md={6} style={{ margin: "0px" }}>
                    <label>Choice Heading:</label>
                    <input
                      type="text"
                      name="choiceHeading"
                      value={formValues.choiceHeading}
                      onChange={handleInputChange}
                       style={{ width: "100%", height: "50px", }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={6} md={4} style={{ margin: "0px" }}>
                    <h2 style={{ margin: "0px 0px 10px 0px" }}>Choice Images:</h2>

                    <ImageUpload
                      avatar
                      fileValue={file2}
                      imagePreviewUrlValue={imagePreviewUrl2}
                      handleImageChange={handleImageChange2}
                      handleRemove={handleRemove2}
                      addButtonProps={{
                        color: "rose",
                        round: true,
                      }}
                      changeButtonProps={{
                        color: "rose",
                        round: true,
                      }}
                      removeButtonProps={{
                        color: "danger",
                        round: true,
                      }}
                    />
                  </GridItem>
                </GridContainer>

                <div>
                  <label>Choice Description:</label>
                  <RichTextEditor
                    value={editorBody2}
                    onChange={handleEditorChange2}
                    style={{ height: "300px" }}
                    
                  />
                </div>


                <GridContainer style={{ justifyContent: "space-between" }}>
                  <GridItem xs={12} sm={6} md={4} style={{ margin: "0px" }}>
                    <h2 style={{ margin: "0px 0px 10px 0px" }}>Business Images:</h2>

                    <ImageUpload
                      avatar
                      fileValue={file3}
                      imagePreviewUrlValue={imagePreviewUrl3}
                      handleImageChange={handleImageChange3}
                      handleRemove={handleRemove3}
                      addButtonProps={{
                        color: "rose",
                        round: true,
                      }}
                      changeButtonProps={{
                        color: "rose",
                        round: true,
                      }}
                      removeButtonProps={{
                        color: "danger",
                        round: true,
                      }}
                    />

                  </GridItem>
                  <GridItem xs={12} sm={6} md={6} style={{ margin: "0px" }}>
                    <label>Business Heading:</label>
                    <input
                      type="text"
                      name="businessHeading"
                      value={formValues.businessHeading}
                      onChange={handleInputChange}
                       style={{ width: "100%", height: "50px", }}
                    />
                  </GridItem>

                </GridContainer>


                <div>
                  <label>Business Description:</label>

                  <RichTextEditor
                    value={editorBody3}
                    onChange={handleEditorChange3}
                    style={{ height: "300px" }}
                  />
                </div>

                <GridContainer style={{ justifyContent: "space-between" }}>
                  <GridItem xs={12} sm={6} md={6} style={{ margin: "0px" }}>
                    <label>secure Heading:</label>
                    <input
                      type="text"
                      name="secureHeading"
                      value={formValues.secureHeading}
                      onChange={handleInputChange}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={6} md={4} style={{ margin: "0px" }}>
                    <h2 style={{ margin: "0px 0px 10px 0px" }}>Choice Images:</h2>

                    <ImageUpload
                      avatar
                      fileValue={file4}
                      imagePreviewUrlValue={imagePreviewUrl4}
                      handleImageChange={handleImageChange4}
                      handleRemove={handleRemove4}
                      addButtonProps={{
                        color: "rose",
                        round: true,
                      }}
                      changeButtonProps={{
                        color: "rose",
                        round: true,
                      }}
                      removeButtonProps={{
                        color: "danger",
                        round: true,
                      }}
                    />
                  </GridItem>
                </GridContainer>

                <div>
                  <label>Secure Description:</label>

                  <RichTextEditor
                    value={editorBody4}
                    onChange={handleEditorChange4}
                    style={{ height: "300px" }}
                  />
                </div>


                <div style={{ margin: "26px 0px 0px 50%" }}>
                  <button type="submit" style={{
                    padding: "16px 26px",
                    fontSize: "medium",
                    backgroundColor: "blue"
                  }}
                  >
                    Submit
                  </button>
                </div>

              </form >
              {alert}
            </div >
          </CardBody>
        </Card>
      </GridItem>
      {alert}
    </GridContainer>
  );
};

export default AboutUs;
